import React from "react";
import { Banknote, CreditCard } from "lucide-react";

const ALL_OPTIONS = [
  {
    id: "cod",
    title: "Cash on delivery",
    subtitle: "Pay when your order arrives at your door",
    icon: Banknote,
    flagKey: "cod",
  },
  {
    id: "razorpay",
    title: "Pay online",
    subtitle: "UPI, cards & wallets via Razorpay",
    icon: CreditCard,
    flagKey: "razorpay",
  },
];

const PaymentMethod = ({
  paymentMethod,
  setPaymentMethod,
  codEnabled = true,
  razorpayEnabled = true,
}) => {
  const enabled = { cod: codEnabled, razorpay: razorpayEnabled };
  const options = ALL_OPTIONS.filter((o) => enabled[o.flagKey]);

  if (options.length === 0) {
    return (
      <p className="rounded-2xl border border-amber-200 bg-amber-50/80 p-4 text-sm font-medium text-amber-900">
        No payment methods are available right now.
      </p>
    );
  }

  return (
    <div
      className={`grid gap-3 ${options.length > 1 ? "sm:grid-cols-2" : "sm:max-w-md"}`}
    >
      {options.map(({ id, title, subtitle, icon: Icon }) => {
        const selected = paymentMethod === id;
        return (
          <button
            key={id}
            type="button"
            onClick={() => setPaymentMethod(id)}
            className={`relative flex gap-3 rounded-2xl border-2 p-4 text-left transition-all duration-200 ${
              selected
                ? "border-orange-500 bg-orange-50/80 shadow-md ring-1 ring-orange-200"
                : "border-stone-200 bg-white hover:border-stone-300 hover:bg-stone-50/80"
            }`}
          >
            <span
              className={`flex h-11 w-11 shrink-0 items-center justify-center rounded-xl ${
                selected ? "bg-orange-500 text-white" : "bg-stone-100 text-stone-600"
              }`}
            >
              <Icon className="h-5 w-5" strokeWidth={2} />
            </span>
            <span className="min-w-0 flex-1">
              <span className="block font-semibold text-stone-900">{title}</span>
              <span className="mt-0.5 block text-sm text-stone-600">{subtitle}</span>
            </span>
            <span
              className={`mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full border-2 ${
                selected
                  ? "border-orange-500 bg-orange-500"
                  : "border-stone-300 bg-white"
              }`}
            >
              {selected ? <span className="h-2 w-2 rounded-full bg-white" /> : null}
            </span>
          </button>
        );
      })}
    </div>
  );
};

export default PaymentMethod;
